"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FETCH_ITEMS_LIMIT = exports.STORAGE_TYPE = exports.LIST_SCOPE = exports.PLACE_LEGEND = exports.TASK_TYPE = exports.DEFAULT_LISTS_IDS = exports.LIST_TYPE = exports.LIST_ACCESS_RIGHT_FOR_WEB_USER = exports.LIST_ACCESS_RIGHT_FOR_MOBILE_USER = void 0;
/**
 * List Access Right for App user
 */
var LIST_ACCESS_RIGHT_FOR_MOBILE_USER;
(function (LIST_ACCESS_RIGHT_FOR_MOBILE_USER) {
    LIST_ACCESS_RIGHT_FOR_MOBILE_USER["FULL_ACCESS"] = "FULL_ACCESS";
    LIST_ACCESS_RIGHT_FOR_MOBILE_USER["READ_ONLY"] = "READ_ONLY";
    LIST_ACCESS_RIGHT_FOR_MOBILE_USER["EDIT_ONLY"] = "EDIT_ONLY";
    LIST_ACCESS_RIGHT_FOR_MOBILE_USER["READ_AND_EDIT"] = "READ_AND_EDIT";
    LIST_ACCESS_RIGHT_FOR_MOBILE_USER["READ_AND_CREATE"] = "READ_AND_CREATE";
    LIST_ACCESS_RIGHT_FOR_MOBILE_USER["READ_CREATE_AND_EDIT"] = "READ_CREATE_AND_EDIT";
})(LIST_ACCESS_RIGHT_FOR_MOBILE_USER || (exports.LIST_ACCESS_RIGHT_FOR_MOBILE_USER = LIST_ACCESS_RIGHT_FOR_MOBILE_USER = {}));
/**
 * List Access Right for Web user
 */
var LIST_ACCESS_RIGHT_FOR_WEB_USER;
(function (LIST_ACCESS_RIGHT_FOR_WEB_USER) {
    LIST_ACCESS_RIGHT_FOR_WEB_USER["NO_ACCESS"] = "NO_ACCESS";
    LIST_ACCESS_RIGHT_FOR_WEB_USER["READ_ONLY"] = "READ_ONLY";
    LIST_ACCESS_RIGHT_FOR_WEB_USER["FULL_ACCESS"] = "FULL_ACCESS";
})(LIST_ACCESS_RIGHT_FOR_WEB_USER || (exports.LIST_ACCESS_RIGHT_FOR_WEB_USER = LIST_ACCESS_RIGHT_FOR_WEB_USER = {}));
/**
 * List Type
 */
var LIST_TYPE;
(function (LIST_TYPE) {
    LIST_TYPE["GENERIC"] = "GENERIC";
    LIST_TYPE["SKU"] = "SKU";
    LIST_TYPE["CUSTOMER"] = "CUSTOMER";
    LIST_TYPE["TERRITORY"] = "TERRITORY";
    LIST_TYPE["PRICE"] = "PRICE";
    LIST_TYPE["CUSTOMER_GROUP"] = "CUSTOMER_GROUP";
    LIST_TYPE["PACKAGING"] = "PACKAGING";
    LIST_TYPE["STOCK"] = "STOCK";
    LIST_TYPE["STORAGE"] = "STORAGE";
})(LIST_TYPE || (exports.LIST_TYPE = LIST_TYPE = {}));
var DEFAULT_LISTS_IDS;
(function (DEFAULT_LISTS_IDS) {
    DEFAULT_LISTS_IDS["SKU"] = "sku";
    DEFAULT_LISTS_IDS["CUSTOMER"] = "customer";
    DEFAULT_LISTS_IDS["PRICE"] = "price";
    DEFAULT_LISTS_IDS["CUSTOMER_GROUP"] = "customergroup";
    DEFAULT_LISTS_IDS["PACKAGING"] = "packaging";
    DEFAULT_LISTS_IDS["TERRITORIES"] = "territories";
    DEFAULT_LISTS_IDS["STOCK"] = "stock";
    DEFAULT_LISTS_IDS["STORAGE"] = "storage";
})(DEFAULT_LISTS_IDS || (exports.DEFAULT_LISTS_IDS = DEFAULT_LISTS_IDS = {}));
/**
 * Type of task
 */
var TASK_TYPE;
(function (TASK_TYPE) {
    TASK_TYPE["WORKFLOW_BASED"] = "WORKFLOW_BASED";
    TASK_TYPE["SIMPLE"] = "SIMPLE";
})(TASK_TYPE || (exports.TASK_TYPE = TASK_TYPE = {}));
/**
 * Place Legend
 */
var PLACE_LEGEND;
(function (PLACE_LEGEND) {
    PLACE_LEGEND["TYPE"] = "type";
    PLACE_LEGEND["USER"] = "user";
    PLACE_LEGEND["LAST_VISIT"] = "last_visit";
})(PLACE_LEGEND || (exports.PLACE_LEGEND = PLACE_LEGEND = {}));
/**
 * List Scope
 */
var LIST_SCOPE;
(function (LIST_SCOPE) {
    LIST_SCOPE["GLOBAL"] = "GLOBAL";
    LIST_SCOPE["TEAM"] = "TEAM";
    LIST_SCOPE["SINGLE_TEAM"] = "SINGLE_TEAM";
    LIST_SCOPE["MOBILE_USER"] = "MOBILE_USER";
    LIST_SCOPE["SINGLE_MOBILE_USER"] = "SINGLE_MOBILE_USER";
})(LIST_SCOPE || (exports.LIST_SCOPE = LIST_SCOPE = {}));
var STORAGE_TYPE;
(function (STORAGE_TYPE) {
    STORAGE_TYPE["VAN"] = "VAN";
    STORAGE_TYPE["WAREHOUSE"] = "WAREHOUSE";
})(STORAGE_TYPE || (exports.STORAGE_TYPE = STORAGE_TYPE = {}));
exports.FETCH_ITEMS_LIMIT = 2000;
